// extracted by mini-css-extract-plugin
export default {"navContainer":"d2jzqFtiYhvWDupQu9rc","innerWrapper":"m29eUouv82TzWHG3b8Uw","iconContainer":"ettUDlvF3OYWn7gRYh8n","selected":"XVJekfeGX6JKay03cz26","icon":"g_MG1p4WSTiR817Lp0jl"};